import React from 'react'
import ReactFlow from 'reactflow'
import './reactFlow.css'
import { Tooltip } from '@mui/material'
import './HierarchyView.css'

const HierarchyView = (props: any): JSX.Element => {
  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 10) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 10)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  interface EdgeData {
    id: string
    source: string
    target: string
    type?: string
    markerEnd?: {
      type?: string
      width?: number
      height?: number
      color?: string
    }
    style: {
      strokeWidth: number
      stroke: string
      borderRadius?: string
    }
  }
  const edges: any = []

  interface NodeData {
    id?: string
    type: string
    sourcePosition?: string
    targetPosition?: string
    data?: {
      label?: any
    }
    position: { x: number, y: number }
  }

  const nodes: any = [
    {
      id: props?.site?.id,
      type: 'input',
      sourcePosition: 'bottom',
      data: {
        label: (
            <>
              <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Site</div>
              {formatTextWithTooltip(props?.site?.name)}
            </>
        )
      },
      position: { x: 0, y: 0 },
      className: 'selected'
    }
  ]

  let assetYPosition = 100 // Initial Y position for assets

  props?.site?.assetList?.forEach((asset: any, assetIndex: number) => {
    const nodeData: NodeData = {
      id: asset?.id,
      type: 'default',
      targetPosition: 'left',
      sourcePosition: 'bottom',
      data: {
        label: (
            <>
              <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Asset</div>
          {formatTextWithTooltip(asset?.name)}
            </>
        )
      },
      position: { x: 200, y: assetYPosition }
    }
    nodes?.push(nodeData)

    const edgesData: EdgeData = {
      id: `${parseInt(props?.site?.id)}-${parseInt(asset?.id)}`,
      source: props?.site?.id,
      target: asset?.id,
      type: 'step',
      markerEnd: {
        type: 'arrow',
        width: 20,
        height: 20,
        color: '#818181'
      },
      style: {
        strokeWidth: 1,
        stroke: '#818181'
      }
    }
    edges?.push(edgesData)

    let gatewayYPosition = assetYPosition + 100 // Initial Y position for gateways

    asset?.gateway?.forEach((gateway: any) => {
      const deviceCount = Array.isArray(gateway?.device) ? gateway.device.length : 0 // Get the number of devices for the gateway // Get the number of devices for the gateway
      const gatewayHeight = Math.max(deviceCount * 100, 100) // Calculate height based on devices
      const nodeData2: NodeData = {
        id: `${parseInt(asset?.id)}-${parseInt(gateway?.id)}-gateway`,
        type: 'default',
        targetPosition: 'left',
        sourcePosition: 'bottom',
        data: {
          label: (
              <>
                <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Gateway</div>
                {formatTextWithTooltip(gateway?.name)}
                </>
          )
        },
        position: { x: 400, y: gatewayYPosition }
      }
      nodes?.push(nodeData2)

      const edgesData2: EdgeData = {
        id: `${parseInt(asset?.id)}-${parseInt(gateway?.id)}`,
        source: asset?.id,
        target: `${parseInt(asset?.id)}-${parseInt(gateway?.id)}-gateway`,
        type: 'step',
        markerEnd: {
          type: 'arrow',
          width: 20,
          height: 20,
          color: '#818181'
        },
        style: {
          strokeWidth: 1,
          stroke: '#818181'
        }
      }
      edges?.push(edgesData2)

      // Reset device Y position for each gateway
      let deviceYPosition = gatewayYPosition + 100

      gateway?.device?.forEach((device: any) => {
        const nodeData3: NodeData = {
          id: `${String(gateway?.id)}-${String(device?.id)}-device`,
          type: 'output',
          targetPosition: 'left',
          sourcePosition: 'bottom',
          data: {
            label: (
                <>
                  <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Device</div>
                  {formatTextWithTooltip(device?.name)}
                </>
            )
          },
          position: { x: 600, y: deviceYPosition }
        }
        nodes?.push(nodeData3)

        const edgesData3: EdgeData = {
          id: `${parseInt(asset?.id)}-${parseInt(gateway?.id)}-${parseInt(device?.id)}`,
          source: `${parseInt(asset?.id)}-${parseInt(gateway?.id)}-gateway`,
          target: `${String(gateway?.id)}-${String(device?.id)}-device`,
          type: 'step',
          markerEnd: {
            type: 'arrow',
            width: 20,
            height: 20,
            color: '#818181'
          },
          style: {
            strokeWidth: 1,
            stroke: '#818181'
          }
        }
        edges?.push(edgesData3)

        deviceYPosition += 100 // Increase Y position for the next device
      })

      gatewayYPosition += gatewayHeight + 50 // Increase Y position for the next gateway
    })

    assetYPosition = gatewayYPosition + 50 // Increase Y position for the next asset
  })

  return (
      <div className={`site-hierarchy-view ${(nodes.length > 7 ? 'site-extra-nodes' : '')}`}>
        <ReactFlow
            nodes={nodes}
            edges={edges}
            fitView
            fitViewOptions={{
              padding: 2
            }}
            nodesDraggable={false}
            zoomOnDoubleClick={true}
            snapToGrid={true}
            snapGrid={[15, 15]}
            style={{ width: '100%', height: '100%' }}
        />
      </div>
  )
}

export default HierarchyView
